export default __webpack_public_path__ + "static/media/O-006.d5abe57b.png";